export const administration = {
    route: 'Administrácia',
    allHomesLabel: 'Všetky miesta',
    allUsersLabel: 'Všetci užívatelia',
    sureToDeleteUserContent: 'Meno užívateľa na vymazanie: ',
    sureToUndeleteUserContent: 'Meno užívateľa na obnovenie: ',
    invitationPending: 'Pozvánka bola odoslaná'
};
